import { PayloadStates } from '@lore/utils';
import useEducatorProjectEvaluationsCompleted from './useEducatorProjectEvaluationsCompleted';
import useEducatorEventEvaluationsCompleted from './useEducatorEventEvaluationsCompleted';

export default function useEducatorEvaluationsCompleted(network, timestamp) {
  const projectEvaluations = useEducatorProjectEvaluationsCompleted(network, timestamp);
  const eventEvaluations = useEducatorEventEvaluationsCompleted(network, timestamp);

  if (
    projectEvaluations.state === PayloadStates.FETCHING ||
    eventEvaluations.state === PayloadStates.FETCHING
  ) {
    return {
      state: PayloadStates.FETCHING,
      data: [],
      meta: {}
    };
  }

  return {
    state: PayloadStates.RESOLVED,
    meta: {
      totalCount: projectEvaluations.meta.totalCount + eventEvaluations.meta.totalCount
    }
  };
}
